import { IBaseUser } from 'src/app/core';

export interface IPatientFilesQuery {
  doctorId: number;
  startDate: string;
  endDate: string;
}

export interface IPatientArchivesQuery {
  userIds: (number | string)[];
  startDate: string;
  endDate: string;
}

export interface IPatientFilesResponse {
  data: IBaseUser[];
}
